var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import 'bootstrap/dist/js/bootstrap';
import 'moment/locale/tr';
import createBrowserHistory from 'history/createBrowserHistory';
import * as $ from 'jquery';
import * as React from 'react';
import { Router } from 'react-router';
import { NavLink, Route } from 'react-router-dom';
import * as Guest from 'src/app/guest';
import Common from './app/common';
import Core from './app/core';
import Users from './app/users';
import { Spin } from 'antd';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import Login from './app/core/auth/Login';
import Dashboard from './app/core/Dashboard';
import blank_profile from './shared/assets/images/blank_profile.jpg';
import logo_fka from './shared/assets/images/logo_light_fka.png';
import logo_malorsa from './shared/assets/images/logo_light_malarso.png';
import stores from './stores/stores';
import NotFound from './app/core/404';
export var history = createBrowserHistory();
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        var _this = this;
        Promise.all([stores.auth.getUser(), stores.user.load(), stores.constant.load()]).then(function () {
            _this.loading = false;
        });
        document.body.className = 'navbar-top';
        var navClass = 'nav-sidebar';
        var navItemClass = 'nav-item';
        var navItemOpenClass = 'nav-item-open';
        var navLinkClass = 'nav-link';
        var navSubmenuClass = 'nav-group-sub';
        var navSlidingSpeed = 250;
        // Configure collapsible functionality
        $(document).on('click', '.nav-sidebar .nav-item:has(.nav-group-sub) .nav-link:not(.disabled)', function (e) {
            // e.preventDefault();
            // Simplify stuff
            var $target = $(e.target);
            var $navSidebarMini = $('.sidebar-xs')
                .not('.sidebar-mobile-main')
                .find('.sidebar-main .' + navClass)
                .children('.' + navItemClass);
            // Collapsible
            if ($target.parent('.' + navItemClass).hasClass(navItemOpenClass)) {
                $target
                    .parent('.' + navItemClass)
                    .not($navSidebarMini)
                    .removeClass(navItemOpenClass)
                    .children('.' + navSubmenuClass)
                    .slideUp(navSlidingSpeed);
            }
            else {
                $target
                    .parent('.' + navItemClass)
                    .not($navSidebarMini)
                    // .addClass(navItemOpenClass)
                    .children('.' + navSubmenuClass)
                    .slideDown(navSlidingSpeed);
            }
            // Accordion
            if ($target.parents('.' + navClass).data('nav-type') === 'accordion') {
                $target
                    .parent('.' + navItemClass)
                    .not($navSidebarMini)
                    .siblings(':has(.' + navSubmenuClass + ')')
                    .removeClass(navItemOpenClass)
                    .children('.' + navSubmenuClass)
                    .slideUp(navSlidingSpeed);
            }
        });
        // Configure collapsible functionality
        // Disable click in disabled navigation items
        $(document).on('click', '.' + navClass + ' .disabled', function (e) {
            e.preventDefault();
        });
        // Scrollspy navigation
        $('.nav-scrollspy')
            .find('.' + navItemClass)
            .has('.' + navSubmenuClass)
            .children('.' + navItemClass + ' > ' + '.' + navLinkClass)
            .off('click');
        var navigationNavbar = function () {
            // Prevent dropdown from closing on click
            $(document).on('click', '.dropdown-content', function (e) {
                e.stopPropagation();
            });
            // Disabled links
            $(document).on('click', '.navbar-nav .disabled a, .nav-item-levels .disabled', function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
            // Show tabs inside dropdowns
            $(document).on('click', '.dropdown-content a[data-toggle="tab"]', function () {
                $(_this).tab('show');
            });
        };
        // Flip 2nd level if menu overflows
        // bottom edge of browser window
        var revertBottomMenus = function () {
            $('.sidebar-main')
                .find('.nav-sidebar')
                .children('.nav-item-submenu')
                .hover(function () {
                var totalHeight = 0;
                var $this = $(this);
                // tslint:disable-next-line:no-shadowed-variable
                var navSubmenuClass = 'nav-group-sub';
                var navSubmenuReversedClass = 'nav-item-submenu-reversed';
                totalHeight += $this
                    .find('.' + navSubmenuClass)
                    .filter(':visible')
                    .outerHeight();
                if ($this.children('.' + navSubmenuClass).length) {
                    if ($this.children('.' + navSubmenuClass).offset().top +
                        $this
                            .find('.' + navSubmenuClass)
                            .filter(':visible')
                            .outerHeight() >
                        document.body.clientHeight) {
                        $this.addClass(navSubmenuReversedClass);
                    }
                    else {
                        $this.removeClass(navSubmenuReversedClass);
                    }
                }
            });
        };
        // If sidebar is resized by default
        if ($('body').hasClass('sidebar-xs')) {
            revertBottomMenus();
        }
        // Toggle min sidebar class
        $(document).on('click', '.sidebar-main-toggle', function (e) {
            e.preventDefault();
            $('body')
                .toggleClass('sidebar-xs')
                .removeClass('sidebar-mobile-main');
            revertBottomMenus();
        });
        $(document).on('click', '.sidebar-main-hide', function (e) {
            e.preventDefault();
            $('body').toggleClass('sidebar-main-hidden');
        });
        $(document).on('click', '.sidebar-secondary-toggle', function (e) {
            e.preventDefault();
            $('body').toggleClass('sidebar-secondary-hidden');
        });
        $(document).on('click', '.sidebar-right-main-toggle', function (e) {
            e.preventDefault();
            // Right sidebar visibility
            $('body').toggleClass('sidebar-right-visible');
            // If visible
            if ($('body').hasClass('sidebar-right-visible')) {
                // Make main sidebar mini
                $('body').addClass('sidebar-xs');
                // Hide children lists if they are opened, since sliding animation adds inline CSS
                $('.sidebar-main .nav-sidebar')
                    .children('.nav-item')
                    .children('.nav-group-sub')
                    .css('display', '');
            }
            else {
                $('body').removeClass('sidebar-xs');
            }
        });
        $(document).on('click', '.sidebar-right-main-hide', function (e) {
            e.preventDefault();
            // Opposite sidebar visibility
            $('body').toggleClass('sidebar-right-visible');
            // If visible
            if ($('body').hasClass('sidebar-right-visible')) {
                $('body').addClass('sidebar-main-hidden');
            }
            else {
                $('body').removeClass('sidebar-main-hidden');
            }
        });
        $(document).on('click', '.sidebar-right-toggle', function (e) {
            e.preventDefault();
            $('body').toggleClass('sidebar-right-visible');
        });
        navigationNavbar();
        if (!history.location.pathname.startsWith('/guest')) {
            setInterval(function () {
                stores.auth.getUser();
            }, 5000);
        }
    };
    default_1.prototype.render = function () {
        var logo = logo_malorsa;
        try {
            logo = stores.auth.hasRole('osb yetkilisi') ? logo_malorsa : logo_fka;
            // tslint:disable-next-line:no-empty
        }
        catch (_a) { }
        return this.loading ? (React.createElement("div", { className: "container", style: { display: 'flex', flexDirection: 'row', justifyContent: 'center' } },
            React.createElement(Spin, null))) : (React.createElement(Router, { history: history }, history.location.pathname.startsWith('/404') ? (React.createElement(NotFound, null)) : history.location.pathname.startsWith('/guest') ? (React.createElement(Route, { exact: true, path: "/guest/company/:email/:token", component: Guest.Company })) : stores.auth.user == null ? (React.createElement(Login, null)) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "navbar navbar-expand-md navbar-dark bg-indigo navbar-static fixed-top" },
                React.createElement("div", { className: "navbar-brand" },
                    React.createElement("a", { href: "/", className: "d-inline-block" },
                        React.createElement("img", { src: logo }))),
                React.createElement("div", { className: "d-md-none" },
                    React.createElement("button", { className: "navbar-toggler", type: "button", "data-toggle": "collapse", "data-target": "#navbar-mobile" },
                        React.createElement("i", { className: "icon-tree5" })),
                    React.createElement("button", { className: "navbar-toggler sidebar-mobile-main-toggle", type: "button" },
                        React.createElement("i", { className: "icon-paragraph-justify3" }))),
                React.createElement("div", { className: "collapse navbar-collapse", id: "navbar-mobile" },
                    React.createElement("ul", { className: "navbar-nav" },
                        React.createElement("li", { className: "nav-item" },
                            React.createElement("a", { href: "#", className: "navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block" },
                                React.createElement("i", { className: "icon-paragraph-justify3" })))),
                    React.createElement("ul", { className: "navbar-nav ml-auto" },
                        React.createElement("li", { className: "nav-item dropdown dropdown-user" },
                            React.createElement("a", { href: "javascript:;", className: "navbar-nav-link d-flex align-items-center dropdown-toggle", "data-toggle": "dropdown" },
                                React.createElement("img", { src: blank_profile, className: "rounded-circle mr-2", height: "34" }),
                                React.createElement("span", null, stores.auth.user.name)),
                            React.createElement("div", { className: "dropdown-menu dropdown-menu-right" },
                                React.createElement(NavLink, { className: "dropdown-item", to: "/users/profile" },
                                    React.createElement("i", { className: "icon-user-plus" }),
                                    " Profilim"),
                                React.createElement("div", { className: "dropdown-divider" }),
                                React.createElement("a", { href: "javascript:;", className: "dropdown-item", onClick: function () { return stores.auth.logout(); } },
                                    React.createElement("i", { className: "icon-switch2" }),
                                    " \u00C7\u0131k\u0131\u015F Yap")))))),
            React.createElement("div", { className: "page-content" },
                React.createElement("div", { className: "sidebar sidebar-light sidebar-main sidebar-fixed sidebar-expand-md" },
                    React.createElement("div", { className: "sidebar-mobile-toggler text-center" },
                        React.createElement("a", { href: "#", className: "sidebar-mobile-main-toggle" },
                            React.createElement("i", { className: "icon-arrow-left8" })),
                        "Navigation",
                        React.createElement("a", { href: "#", className: "sidebar-mobile-expand" },
                            React.createElement("i", { className: "icon-screen-full" }),
                            React.createElement("i", { className: "icon-screen-normal" }))),
                    React.createElement("div", { className: "sidebar-content" },
                        React.createElement("div", { className: "sidebar-user-material" },
                            React.createElement("div", { className: "sidebar-user-material-body" },
                                React.createElement("div", { className: "card-body text-center" },
                                    React.createElement("a", { href: "#" },
                                        React.createElement("img", { src: blank_profile, className: "img-fluid rounded-circle shadow-1 mb-3", width: "80", height: "80" })),
                                    React.createElement("h6", { className: "mb-0 text-white text-shadow-dark" }, stores.auth.user.name),
                                    React.createElement("span", { className: "font-size-sm text-white text-shadow-dark" }, stores.auth.user.roles.join(' '))),
                                React.createElement("div", { className: "sidebar-user-material-footer" },
                                    React.createElement("a", { href: "#user-nav", className: "d-flex justify-content-between align-items-center text-shadow-dark dropdown-toggle", "data-toggle": "collapse" },
                                        React.createElement("span", null, "Navigation")))),
                            React.createElement("div", { className: "collapse", id: "user-nav" },
                                React.createElement("ul", { className: "nav nav-sidebar" },
                                    React.createElement("li", { className: "nav-item" },
                                        React.createElement(NavLink, { className: "nav-link", to: "/users/profile" },
                                            React.createElement("i", { className: "icon-user-plus" }),
                                            React.createElement("span", null, "Profilim"))),
                                    React.createElement("li", { className: "nav-item" },
                                        React.createElement("a", { href: "javascript:;", className: "nav-link", onClick: function () { return stores.auth.logout(); } },
                                            React.createElement("i", { className: "icon-switch2" }),
                                            React.createElement("span", null, "\u00C7\u0131k\u0131\u015F Yap")))))),
                        React.createElement("div", { className: "card card-sidebar-mobile" },
                            React.createElement("ul", { className: "nav nav-sidebar", "data-nav-type": "accordion" },
                                React.createElement("li", { className: "nav-item-header" },
                                    React.createElement("div", { className: "text-uppercase font-size-xs line-height-xs" }, "Men\u00FC"),
                                    React.createElement("i", { className: "icon-menu", title: "Main" })),
                                React.createElement("li", { className: "nav-item" },
                                    React.createElement(NavLink, { className: "nav-link", exact: true, to: "/" },
                                        React.createElement("i", { className: "icon-home4" }),
                                        React.createElement("span", null, "Anasayfa"))),
                                React.createElement("li", { className: "nav-item" },
                                    React.createElement(NavLink, { className: "nav-link", exact: true, to: "/common/company" },
                                        React.createElement("i", { className: "icon-copy" }),
                                        React.createElement("span", null, "Ba\u015Fvurular"))),
                                stores.auth.hasRole('administrator') && (React.createElement("div", null,
                                    React.createElement("li", { className: "nav-item" },
                                        React.createElement(NavLink, { className: "nav-link", to: "/core/constant" },
                                            React.createElement("i", { className: "icon-list-unordered" }),
                                            React.createElement("span", null, "Sabitler"))),
                                    React.createElement("li", { className: "nav-item" },
                                        React.createElement(NavLink, { className: "nav-link", to: "/common/score" },
                                            React.createElement("i", { className: "icon-list-numbered" }),
                                            React.createElement("span", null, "Puanlamalar"))),
                                    React.createElement("li", { className: "nav-item" },
                                        React.createElement(NavLink, { className: "nav-link", to: "/common/file-category" },
                                            React.createElement("i", { className: "icon-files-empty" }),
                                            React.createElement("span", null, "Dosya Kategorileri"))),
                                    React.createElement("li", { className: "nav-item" },
                                        React.createElement(NavLink, { className: "nav-link", to: "/users/user" },
                                            React.createElement("i", { className: "icon-people" }),
                                            React.createElement("span", null, "Kullan\u0131c\u0131lar"))),
                                    React.createElement("li", { className: "nav-item" },
                                        React.createElement(NavLink, { className: "nav-link", exact: true, to: "/core/setting" },
                                            React.createElement("i", { className: "icon-cog" }),
                                            React.createElement("span", null, "Ayarlar"))))))))),
                React.createElement("div", { className: "content-wrapper" },
                    React.createElement(Route, { exact: true, path: "/", component: Dashboard }),
                    React.createElement(Route, { exact: true, path: "/common/company", component: Common.Company.List }),
                    React.createElement(Route, { exact: true, path: "/common/company/:id", component: Common.Company.Edit }),
                    React.createElement(Route, { exact: true, path: "/common/company/view/:id", component: Common.Company.View }),
                    React.createElement(Route, { exact: true, path: "/common/company/rapor/:id", component: Common.Company.Rapor }),
                    React.createElement(Route, { exact: true, path: "/users/profile", component: Users.User.Profile }),
                    React.createElement(Route, { exact: true, path: "/404", component: NotFound }),
                    stores.auth.hasRole('administrator') && (React.createElement(React.Fragment, null,
                        React.createElement(Route, { exact: true, path: "/common/score/:id", component: Common.Score.Edit }),
                        React.createElement(Route, { exact: true, path: "/common/score", component: Common.Score.List }),
                        React.createElement(Route, { exact: true, path: "/common/file-category/:id", component: Common.FileCategory.Edit }),
                        React.createElement(Route, { exact: true, path: "/common/file-category", component: Common.FileCategory.List }),
                        React.createElement(Route, { exact: true, path: "/users/user", component: Users.User.List }),
                        React.createElement(Route, { path: "/users/user/:id", component: Users.User.Edit }),
                        React.createElement(Route, { exact: true, path: "/core/constant", component: Core.Constant.List }),
                        React.createElement(Route, { path: "/core/constant/:id", component: Core.Constant.Edit }),
                        React.createElement(Route, { exact: true, path: "/core/setting", component: Core.Setting.List }),
                        React.createElement(Route, { path: "/reports/final/:id" })))))))));
    };
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    default_1 = __decorate([
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 71
// module chunks = 0